import React, { useEffect } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useAddAccountGroups } from "@/features/accounts/account-group/hooks/use-add-account-groups";
import { SimpleForm } from "@/shared/components/text-box/simple-form";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { Checkbox } from "@/shared/components/check-box/check-box";


interface Props {
  onTapCloseModal: () => void;
  onTapCompleteModal: () => void;
}

export const AddAccountGroupModal = ({ onTapCloseModal, onTapCompleteModal }: Props) => {
  const {
    accountGroups,
  } = useAccountGroupsContext();

  const {
    accountGroupName,
    isActivateCreateButton,
    registeredAccounts,
    setRegisteredAccounts,
    check,
    onChangeGroupName,
    onChangeCreateButtonState,
    onTapCheckBox,
    addAccountGroups,
  } = useAddAccountGroups({ onTapCompleteModal });

  useEffect(() => {
    onChangeCreateButtonState(accountGroupName);
  }, [accountGroupName]);

  const getInstitutionType = (passbookType: string): string => {
    if (passbookType === "01") {
      return "bank";
    } else if (passbookType === "03" || passbookType === "19659" || passbookType === "19660") {
      return "card";
    } else if (passbookType === "10") {
      return "emoney";
    } else if (passbookType === "20") {
      return "ecshop";
    } else if (passbookType === "201" || passbookType === "202") {
      return "excel";
    } else if (passbookType === "101") {
      return "ocr";
    }
    return "";
  };

  const onSelectAccount = (
    accountGroupId: string,
    mlinkAccountId: string,
    mlinkId: string,
    passbookType: string
  ) => {
    setRegisteredAccounts((prev) => {
      const exists = prev.some(
        (a) => a.account_group_id === accountGroupId
        && a.mlink_account_id === mlinkAccountId
        && a.mlink_id === mlinkId
      );

      // すでに存在する → 削除（チェック外す）
      if (exists) {
        return prev.filter(
          (a) => !(a.account_group_id === accountGroupId
          && a.mlink_account_id === mlinkAccountId
          && a.mlink_id === mlinkId)
        );
      }

      // 存在しない → 追加（チェックする）
      return [
        ...prev,
        {
          account_group_id: accountGroupId,
          mlink_account_id: mlinkAccountId,
          mlink_id: mlinkId,
          passbook_type: passbookType,
        },
      ];
    });
  };

  return (
    <BasePageModal
      handleClose={onTapCloseModal}
      title="新しい口座グループを作成"
      className="md-user-group"
      bottomChildren={
        <BaseRoundButton
          buttonText="新しい口座グループを作成"
          isActive={isActivateCreateButton}
          onClick={() => addAccountGroups(
            accountGroupName.trim(),
            registeredAccounts,
          )}
        />
      }
      disableOverlayClose={true}
    >
      <h2>
        グループ名を設定してください
      </h2>
      <ul>
        <li>
        <SimpleForm
          placeholder="グループ名を入力（必須）"
          onChange={onChangeGroupName}
        />
        </li>
        <li>
          <Checkbox
            label={"このグループに既存の明細帳を移動する"}
            checked={check}
            handleChange={onTapCheckBox}
            className="moveFolder"
          />
          <div id="listMoveFolder">
          {check && (
            <dl>
            {accountGroups.map((group, gIndex) => (
              (!(group.shared === 1 && group.isOwner === 0) && (
              <div className="registered-accounts-item" key={group.accountGroupId}>
                <dt>{group.accountGroupsName}</dt>
                <dd>
                {group.accountsList.map((account, aIndex) => (
                  <div key={account.mlinkId}>
                    {/*passbook_name使いたい場合API側でpassbook_nameをaccount_display_nameとして返す方針でいく*/}
                    <Checkbox
                      label={account.passbookName}
                      checked={registeredAccounts.some(
                        (a) =>
                          a.mlink_account_id === account.mlinkAccountId
                          && a.mlink_id === account.mlinkId
                      )}
                      handleChange={() => {onSelectAccount(
                        group.accountGroupId,
                        account.mlinkAccountId,
                        account.mlinkId,
                        account.passbookType
                      )}}
                      className={`group${gIndex}folder${aIndex}`}
                      labelClassName={`btn-${getInstitutionType(account.passbookType)}`}
                    />
                  </div>
                ))}
                </dd>
              </div>
              ))
            ))}
            </dl>
          )}
          </div>
        </li>
      </ul>
    </BasePageModal>
  );
};
